import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-102">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-103">
        <p className="text-gray-400 font-bold" data-id="element-104">
          Sistema Integrato Italiano™ — Il sistema N.1 per Docenti di Lettere
          nella Scuola Secondaria italiana.
        </p>
        <p data-id="element-105">
          Perché insegnare Dante, Manzoni e Leopardi non dovrebbe costarti ogni
          sera della settimana.
        </p>
        <p data-id="element-106">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-orange transition-colors" data-id="element-107">
            📧 kitonline27@gmail.com
          </a>
        </p>
        <p data-id="element-108">© Sistema Integrato Italiano™ 2026 — Tutti i diritti riservati.</p>
      </div>
    </footer>;
}